import React from 'react';
import PropTypes from 'prop-types';
import config from '../config';

const getCdnUrl = ({src, listingId, userId, size = 'original', filename = 'primary'}) => {
    let cdnUrl;
    const srcParts = `${src}`.split('.');
    const extension = srcParts[srcParts.length - 1];
    const baseCDN = `https://cdn.${config.isProd ? 'snapcheck' : 'gueststay'}.in`;
    if (listingId) {
        cdnUrl = `${baseCDN}/userdata/images/listing/${listingId}/${userId}/${size}.${extension}`;
    }
    if (!listingId && userId) {
        cdnUrl = `${baseCDN}/userdata/images/logo/${userId}/${size}.${filename}.${extension}`;
    }
    return cdnUrl;
}

const CDNImage = React.forwardRef(function CDNImage(props, ref) {
    const {src, listingId, userId, size, filename, ...options} = props;
    const cdnUrl = getCdnUrl(props);
    const [imgsrc, setImgSrc] = React.useState(cdnUrl || src);
    const handleImageError = () => {
        console.log(`CDNImage failed to load ${cdnUrl}`);
        if (imgsrc !== src) {
            setImgSrc(src);
        }
    }

    const imageProps = {
        ...options,
        src: imgsrc,
        onError: handleImageError,
    };

    return <img {...imageProps}/>;
});

CDNImage.propTypes = {
    src: PropTypes.string.isRequired,
    size: PropTypes.string,
    userId: PropTypes.string,
    listingId: PropTypes.string,
    filename: PropTypes.string,
};

CDNImage.defaultProps = {
    size: 'original',
    filename: 'primary',
};

export {getCdnUrl};
export default CDNImage;